import { Component, inject, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { TokenService } from '../../services/token/token.service';
import { FormatService } from '../../services/format/format.service';
import { Router } from '@angular/router';
import { StorageService } from '../../services/storage/storage.service';

@Component({
  selector: 'app-tiktok-callback',
  standalone: true,
  imports: [HttpClientModule],
  providers: [HttpClient, TokenService],
  templateUrl: './tiktok-callback.component.html',
  styleUrl: './tiktok-callback.component.scss'
})
export class TiktokCallbackComponent implements OnInit {

  tiktokAccount: {
    creatorId: string;
    open_id: string;
    union_id: string;
    avatar_url: string;
    display_name: string;
    follower_count: number;
    following_count: number;
    likes_count: number;
    video_count: number;
    createdDate: string;
    deletedDate: string | null;
  } | undefined;

  connectionError: string | undefined;

  constructor(
    private router: Router,
    private tokenService: TokenService,
    public formatService: FormatService,
    private storageService: StorageService
  ) { }

  ngOnInit() {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const scopes = urlParams.get('scopes');

    console.log('TikTok Auth Code:', code);
    console.log('TikTok Scopes:', scopes);

    if (code) {
      this.exchangeCodeForToken(code);
    }
  }

  async exchangeCodeForToken(code: string) {
    console.log('One ---->');

    try {
      const tokenResponse = await firstValueFrom(this.tokenService.exchangeCodeForTokenTikTok(code));
      console.log('Token exchange successful:', JSON.stringify(tokenResponse));

      if (tokenResponse.error) {
        this.connectionError = tokenResponse.error;
        return;
      } else {
        this.tiktokAccount = tokenResponse;
      }
    } catch (tikTokExchangeError) {
      console.error('TikTok exchange code for token failed:', tikTokExchangeError);
      this.connectionError = 'Something went wrong';
    }
  }

  connectAnotherAccount() {
    console.log('Connect another account');

    const businessId = this.storageService.get('businessId');
    const externalId = this.storageService.get('externalId');

    console.log('External ID:', externalId);
    console.log('Business ID:', businessId);
    this.router.navigate([`/connect/${externalId}/${businessId}`]);
  }

  exitBrowser() {
    console.log('Exit browser');
    window.close();
  }
}


export interface AuthTiktokDto {
  access_token: string;
  expires_in: number;
  open_id: string;
  refresh_expires_in: number;
  refresh_token: string;
  scope: string;
  token_type: string;
  accountId: string;
}